<h2 mat-dialog-title class="mb-3">{{data ? 'Edit Prompt Set' : 'Create new Prompt Set'}}</h2>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form" class="contract-check-form" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline">
            <mat-label>Prompt Set Name</mat-label>
            <input matInput formControlName="name" maxlength="100">
            <mat-hint align="end">{{form.get('name')?.value?.length || 0}}/100</mat-hint>
            @if (form.get('name')?.hasError('required')) {
            <mat-error>
                Name is required
            </mat-error>
            }
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!form.valid" type="submit" (click)="onSubmit()">
        {{data ? 'Save' : 'Create'}}
    </button>
</mat-dialog-actions>